import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=418f0bbb&scoped=true&"
import script from "./project-card.vue?vue&type=script&lang=js&"
export * from "./project-card.vue?vue&type=script&lang=js&"
import style0 from "./project-card.vue?vue&type=style&index=0&id=418f0bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f0bbb",
  null
  
)

export default component.exports